import React from 'react';
import "./servicesDropdown.scss";
import routerIcon from '../../images/Router.svg';
import bandwidthIcon from '../../images/Bandwidth-Monitor.svg';
import nocIcon from '../../images/eNOC.svg';
import OutsideAlerter from "b2b-ui-components-lib/lib/components/outsideAlerter";
const servicesDropdown = ({setShowManageServices}) => {
    const closeToolTip = () =>{
        setShowManageServices(false)
    }
    return (
        <OutsideAlerter onOutsideClick={closeToolTip}>
            <div className="service_dropdown">
                <div className="dropdown_header">
                    <h4 className={'ms'}>Service Type</h4>
                    <span className="cross_icon" onClick={()=>setShowManageServices(false)}></span>
                </div>
                <div className="dropdown_content">
                    <div className="tooltip_table">
                        <p>We provide services that includes-</p>
                        <table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Managed</th>
                                    <th>Partially Managed</th>
                                    <th>Unmanaged</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="service_items">
                                            <div className="item_title">
                                                <img className="icon" src={routerIcon} alt="Router" />
                                                <strong>Router Hardware</strong>
                                            </div>
                                            <div className="item_info">Auto trouble shooting routers</div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="icon_checked"></span>
                                    </td>
                                    <td>
                                        <span className="icon_crossed"></span>
                                    </td>
                                    <td>
                                        <span className="icon_crossed"></span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="service_items">
                                            <div className="item_title">
                                                <img className="icon" src={bandwidthIcon} alt="Bandwidth" />
                                                <strong>Bandwidth Monitor Widget</strong>
                                            </div>
                                            <div className="item_info">Proactive network monitoring</div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="icon_checked"></span>
                                    </td>
                                    <td>
                                        <span className="icon_crossed"></span>
                                    </td>
                                    <td>
                                        <span className="icon_crossed"></span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="service_items">
                                            <div className="item_title">
                                                <img className="icon" src={nocIcon} alt="eNOC" />
                                                <strong>e-NOC Managed Service</strong>
                                            </div>
                                            <div className="item_info">Service availability backed by our industry-leading SLAs and 24*7 support.</div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="icon_checked"></span>
                                    </td>
                                    <td>
                                        <span className="icon_checked"></span>
                                    </td>
                                    <td>
                                        <span className="icon_crossed"></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <ul className="services_items">
                        <li>
                            <div className="item_title">
                                <img className="icon" src={routerIcon} alt="Router" />
                                <strong>Router Hardware</strong>
                            </div>
                            <div className="item_info">Auto trouble shooting routers</div>
                        </li>
                        <li>
                            <div className="item_title">
                                <img className="icon" src={bandwidthIcon} alt="Bandwidth" />
                                <strong>Bandwidth Monitor Widget</strong>
                            </div>
                            <div className="item_info">Proactive network monitoring</div>
                        </li>
                        <li>
                            <div className="item_title">
                                <img className="icon" src={nocIcon} alt="eNOC" />
                                <strong>e-NOC Managed Service</strong>
                            </div>
                            <div className="item_info">Service availability backed by our industry-leading SLAs and 24*7 support.</div>
                        </li>
                    </ul> */}
                </div>
            </div>
        </OutsideAlerter>
    );
}

export default servicesDropdown;
